// extracted by mini-css-extract-plugin
export default {"root":"JqqCZr7K"};